const threads=38;
const draftRows=50;

export {threads, draftRows}